const MinfullAndCognitive = [{
    "test": 'test record'
}, 
{
    "test": 'test record 2'
}];
export default MinfullAndCognitive;